import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/fontawesome/darkest/solid/spinner.svg")